import React from "react";

export const SUBSCRIPTION_FILTER_OPTIONS = [
  { id: "yes", label: "Да" },
  { id: "no", label: "Нет" },
  { id: "expiring15", label: "≤15 дней" },
  { id: "all", label: "Все" },
];

export function FilterChipGroup({
  label,
  options,
  value,
  onChange,
  groupName,
  className = "my-companies-filter-group",
}) {
  return (
    <div className={className}>
      <span className="my-companies-filter-label">{label}</span>
      <div
        className="subscription-period-chips my-companies-filter-chips"
        role="radiogroup"
        aria-label={label}
      >
        {options.map((opt) => (
          <button
            key={opt.id}
            type="button"
            name={groupName}
            className={
              value === opt.id
                ? "subscription-period-chip subscription-period-chip--active"
                : "subscription-period-chip"
            }
            aria-checked={value === opt.id}
            role="radio"
            onClick={() => onChange(opt.id)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function SubscriptionFilterChips({
  value,
  onChange,
  groupName = "company-list-subscription",
  className = "my-companies-filter-group",
}) {
  return (
    <FilterChipGroup
      label="Подписка"
      groupName={groupName}
      options={SUBSCRIPTION_FILTER_OPTIONS}
      value={value ?? "all"}
      onChange={onChange}
      className={className}
    />
  );
}
